import React from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { reqStContentsAction, reqStContentsAddAction, reqStContents2Action, reqStContents2AddAction, setStPriceFilterChangeAction, setStFilterChangeAction } from '../../modules/st/stContentsModule';
import SpaceCardItem from './SpaceCardItem';
import SelectDropDownSmallBtn from '../common/button/SelectDropDownSmallBtn';
import { useState } from 'react';
import SelectOrderBox from '../common/button/SelectOrderBox';
import { filter, forEach } from 'lodash';
import {isMobileOnly} from 'react-device-detect';
import MyEsOrderBox from '../es/MyEsOrderBox';

const SpaceContentsListBlock = styled.div`
    ::after {
        content: '';
        display: block;
        clear: both;
    }
`;

const SpaceContentsSlideWrap = styled.div`
    ${isMobileOnly?"display:flex; flex-wrap: wrap":"margin-left: -63px"};
    //margin-bottom: 40px;
    padding: 0;

    ::after {
        content: '';
        display: block;
        clear: both;
    }
`;
const SpaceOrderBlock = styled.div`
    margin-bottom: 20px;
    ::after {
        content: "";
        display: block;
        clear: both;
    }
`;
const SpaceContentsDropDownBlock = styled.div`
    float: right;
    vertical-align: baseline;
    //width:120px;

`;

const SpaceMoreBlock = styled.p`
    text-align: center;
    height: 64px;
`;

const SpaceMoreBtnBlock = styled.button`
    text-align: center;
    padding-top: 40px;
`;

const Options = [
    { value: 0, label: "인기순" },
    { value: 1, label: "최신순" },
];

const LIMIT_COUNT = 9;
const SpaceContentsList = () => {

    const dispatch = useDispatch();
    const [totalListNum, setTotalListNum] = useState(0);
    const [curFilterOrderIndex, setCurFilterOrderIndex] = useState(0);
    const [offset, setOffset] = useState(0);

    const { stItems, error, loading, minPrice, maxPrice, stDelFilterInfo, stFilterInfo, curPrice, curMinMaxPrice, priceFilterChange, filterChange } = useSelector(
        ({ stContentsReducer, loadingReducer, stFilterReducer }) => ({
            stDelFilterInfo: stContentsReducer.stDelFilterInfo,
            stItems: stContentsReducer.stItems,
            error: stContentsReducer.error,
            minPrice: stContentsReducer.minPrice,
            maxPrice: stContentsReducer.maxPrice,
            loading: loadingReducer['sp/ST_CONTENTS'],
            stFilterInfo: stFilterReducer.stFilterInfo,
            curPrice: stContentsReducer.curPrice,
            curMinMaxPrice: stContentsReducer.curMinMaxPrice,
            priceFilterChange: stContentsReducer.priceFilterChange,
            filterChange: stContentsReducer.filterChange,
        })
    );

    const getFilterString = () => {
        let info = [];
        forEach(stFilterInfo, (item, idx) => {
            let arrFilter = filter(item, function (curitem, idx) {
                return idx !== 0;
            });

            let tempFilterArr = [];
            forEach(arrFilter, (item, idx) => {
                let filtervalue = item.filter1_id * 100 + item.filter2_id * 1;
                tempFilterArr.push(filtervalue);
            })



            let tempFilter = [];
            forEach(tempFilterArr, (item, idx) => {
                if(stDelFilterInfo !== null && stDelFilterInfo.length > 0 &&  !stDelFilterInfo.includes(item)){
                    tempFilter.push(item);
                }
            })
            if(tempFilter !== null && tempFilter.length === 0){
                info.push(tempFilterArr);
            } else {
                info.push(tempFilter);
            }

        })

        let filterString = '(';
        forEach(info, (item, idx) => {
            filterString += '(';
            forEach(item, (curitem, curIdx) => {
                filterString += '_'+curitem + '=' +"'1'";
                if(curIdx < item.length - 1){
                    filterString += ' ' + 'or' + ' '
                }
            })
            filterString += ')';

            if(idx < info.length - 1){
                filterString += ' ' + 'and' + ' '
            }
        })
        filterString += ')';
        //console.log('filterString = ' + filterString);
        //console.log('info = ' + JSON.stringify(info));

        return filterString;
    }

    useEffect(() => {
        // if (stItems === null || stItems === undefined) {
        if(filterChange){
            let price = -1;
            let param = "?minPrice=" + price + "&maxPrice=" + price + "&offset=0&limit=" + LIMIT_COUNT+"&sort="+curFilterOrderIndex;
            param += ("&filter=" + getFilterString());

            setOffset(0);

            //dispatch(setStFilterChangeAction(false));
            dispatch(setStPriceFilterChangeAction(false));

            dispatch(reqStContents2Action(param));
        }
    }, [stDelFilterInfo])

    useEffect(() => {
        if(priceFilterChange){
            //console.log('curprice = ' + curPrice)
            let param = "?minPrice=" + curPrice[0] + "&maxPrice=" + curPrice[1] + "&offset=0&limit=" + LIMIT_COUNT+"&sort="+curFilterOrderIndex;
            param += ("&filter=" + getFilterString());

            setOffset(0);
            dispatch(reqStContents2Action(param));
        }
    }, [curPrice])


    if (stItems === null || stItems === undefined) {
        return <SpaceContentsListBlock />
    } else {
        // console.log("stItems : " + JSON.stringify(stItems));
    }


    const onChangeOrder = (param) => {
        setCurFilterOrderIndex(param.value)

        let param2 = "?minPrice=" + curPrice[0] + "&maxPrice=" + curPrice[1] + "&offset=0&limit=" + LIMIT_COUNT+"&sort="+curFilterOrderIndex;
        param2 += ("&filter=" + getFilterString());

        setOffset(0);
        dispatch(reqStContents2Action(param2));

    }

    const isMoreBtnShow = () => {
        if (stItems === null ||
            stItems === undefined ||
            stItems.length === 0 ) {
            return false;
        }
        else if(stItems.length > 0 && stItems[0].space_total_count > stItems.length){
            return true;
        }

        return false;
    }

    const handlerMoerClick = () => {
        let off = offset + LIMIT_COUNT;
        let param = "?minPrice=" + minPrice + "&maxPrice=" + maxPrice + "&offset="+ off + "&limit="+LIMIT_COUNT+"&sort="+curFilterOrderIndex;
        if (stDelFilterInfo !== null && stDelFilterInfo.length > 0) {
            //param += ("&filter=" + stDelFilterInfo);
        }
        param += ("&filter=" + getFilterString());
        dispatch(reqStContents2AddAction(param));
        //dispatch(reqStContentsAddAction(param));
        setOffset(off);
    }

    return (

        <SpaceContentsListBlock>
            <SpaceOrderBlock>
                <SpaceContentsDropDownBlock>
                    <MyEsOrderBox
                        valueDefault={Options[curFilterOrderIndex]}
                        options={Options}
                        height={'26px'} 
                        onChange={onChangeOrder} />
                    {/* <SelectDropDownSmallBtn
                        height='20px'
                        valueDefault={Options[curFilterOrderIndex]}
                        options={Options}
                        onChange={onChangeOrder} /> */}
                </SpaceContentsDropDownBlock>
            </SpaceOrderBlock>

            <SpaceContentsSlideWrap>
                {
                    stItems.map((curitem, index) => {
                        let top = '10px';
                        if (index > 2&&!isMobileOnly) top = '60px';

                        return <SpaceCardItem
                            key={curitem.st_id}
                            iteminfo={curitem}
                            paddingTop={top} />
                    })
                }
            </SpaceContentsSlideWrap>

            {isMoreBtnShow() ?
                <SpaceMoreBlock>
                    <SpaceMoreBtnBlock onClick={handlerMoerClick}>더보기
                    </SpaceMoreBtnBlock>
                </SpaceMoreBlock> : ''
            }
        </SpaceContentsListBlock>
    );
};

export default SpaceContentsList;
